<template>
  <div class="home-step" id="HomeStep">
    <div class="arrow-page"><div class="blue-ball"></div></div>

    <div class="home-step-img-b desk">
      <img src="@/assets/img/home02.png" alt="DX" />
    </div>

    <div class="container">
      <div class="title">
        <span class="color-b">Meta DXi</span> Platform Roadmap
      </div>
      <div class="body arrow-background">
        <div class="step-container">
          <div class="step">
            <div class="home-step-img-a">
              1
            </div>
            <div class="step-subtitle">
              First version of the exploratory survey
            </div>
            <div class="step-divider"></div>
            <div class="text">
              With help from the market, we will collect data and insights to
              even create unprecedented conversation channels with new and
              existing clients.
            </div>
          </div>
          <div class="step">
            <div class="home-step-img-a">
              2
            </div>
            <div class="step-subtitle">
              Results of exploratory survey & next steps
            </div>
            <div class="step-divider"></div>
            <div class="text">
              We will develop conclusive material to provide to everyone who
              helped us in this construction - in addition to enabling digital
              transformation solutions that are suitable for their businesses.
            </div>
          </div>
          <div class="step">
            <div class="home-step-img-a">
              3
            </div>
            <div class="step-subtitle">
              Exclusive Meta DXi survey
            </div>
            <div class="step-divider"></div>
            <div class="text">
              In partnership with a referenced research institute, we will
              develop a paper on Digital Transformation, creating a source of
              information on the subject for the whole market.
            </div>
          </div>
        </div>
      </div>

      <div class="mob slide-instruction">
        <img src="@/assets/img/slide-instruction.png" />
      </div>

      <div class="footer">
        <div class="sidea">
          <div class="step-title-flex-01">
            You are in Phase 1 of Meta DXi: exploratory survey
          </div>
          <div class="step-complementar-text">
            Take part in it and learn more about your business’s digital
            maturity stage related to <b>four pillars</b>:
          </div>
        </div>
        <div class="sideb">
          <ul class="step-list">
            <li>
              <img src="@/assets/img/pink-arrow.png" />Organizational culture
            </li>
            <li><img src="@/assets/img/pink-arrow.png" />Technology</li>
            <li><img src="@/assets/img/pink-arrow.png" />Strategy</li>
            <li><img src="@/assets/img/pink-arrow.png" />Digital processes</li>
          </ul>
        </div>
      </div>

      <div class="card">
        <div class="sidea orange">
          Shall we build the map of digital transformation together?

          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 arrow"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
        <div class="sideb">
          <a href="#HomeForm">
            <button class="button-28 hover-orange cta-start-btn" role="button">
              START SURVEY
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 orange"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeStep",
  components: {},
  methods: {
    // goToForm() {
    //   console.log("go");
    //   window.scrollTo(0, 0);
    // },
  },
  mounted: () => {},
};
</script>
